import { Component, OnInit } from '@angular/core';
import {NzModalRef} from "ng-zorro-antd/modal";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ApiService} from "../../../../services/api.service";
import {BehaviorSubject, Observable} from "rxjs";

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {

  newUserForm: FormGroup;
  isLoading$: BehaviorSubject<boolean>;
  errorMessage$: BehaviorSubject<string>;

  constructor(private modal: NzModalRef, public fb: FormBuilder, public api: ApiService) {
    this.isLoading$ = new BehaviorSubject<boolean>(false);
    this.errorMessage$ = new BehaviorSubject<string>('');
  }

  destroyModal(): void {
    this.modal.destroy();
  }

  ngOnInit(): void {
    this.newUserForm = this.fb.group({
      email: [null,  Validators.compose([
            Validators.required,
            Validators.email
          ])],
      role: ['user', Validators.required]
    },{
    })
  }

  submitForm(){

    this.isLoading$.next(true);

    this.api.apiPost('core/admin/users/invites', this.newUserForm.value).then((CreateUserResult)=>{
        this.modal.close(CreateUserResult);
    }).catch((CreateUserError)=>{
        this.errorMessage$.next(CreateUserError.error.Error);
        this.isLoading$.next(false);
    })

  }


}
